// Favicon dynamique : badge rouge pulsant quand des notifications sont en attente.

let _img        = null;
let _linkEl     = null;
let _canvas     = null;
let _ctx        = null;
let _pulseTimer = null;
let _pulsePhase = 0;
let _lastN      = 0;

function _getLink() {
    if (_linkEl) return _linkEl;
    _linkEl = document.querySelector("link[rel='icon'][sizes='32x32']");
    if (!_linkEl) {
        _linkEl = document.createElement('link');
        _linkEl.rel   = 'icon';
        _linkEl.type  = 'image/png';
        _linkEl.sizes = '32x32';
        document.head.appendChild(_linkEl);
    }
    return _linkEl;
}

function _getCanvas() {
    if (_canvas) return;
    _canvas = document.createElement('canvas');
    _canvas.width = 32; _canvas.height = 32;
    _ctx = _canvas.getContext('2d');
}

function _draw(glowIntensity) {
    _getCanvas();
    _ctx.clearRect(0, 0, 32, 32);
    if (_img) _ctx.drawImage(_img, 0, 0, 32, 32);
    if (glowIntensity > 0) {
        const blur = 2 + glowIntensity * 12;
        _ctx.save();
        _ctx.shadowColor   = '#ef4444';
        _ctx.shadowBlur    = blur;
        _ctx.globalAlpha   = 0.65 + glowIntensity * 0.35;
        _ctx.fillStyle     = '#ef4444';
        _ctx.beginPath(); _ctx.arc(25, 7, 7, 0, Math.PI * 2); _ctx.fill();
        _ctx.restore();
        _ctx.strokeStyle = '#0d1117'; _ctx.lineWidth = 1.5;
        _ctx.beginPath(); _ctx.arc(25, 7, 7, 0, Math.PI * 2); _ctx.stroke();
    }
    return _canvas.toDataURL();
}

function _stopPulse() {
    if (_pulseTimer) { clearInterval(_pulseTimer); _pulseTimer = null; }
}

function _startPulse() {
    if (_pulseTimer) return;
    const link = _getLink();
    _pulsePhase = 0;
    _pulseTimer = setInterval(() => {
        _pulsePhase += 0.08;
        const glow = 0.5 + 0.5 * Math.sin(_pulsePhase); // 0..1, cycle ~3.9 s
        link.href = _draw(glow);
    }, 50);
}

function _apply(n) {
    _stopPulse();
    if (n === 0) { _getLink().href = _draw(0); return; }
    _startPulse();
}

export function majFavicon(n) {
    _lastN = n;
    if (!_img) {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload  = () => { _img = img; _apply(n); };
        img.onerror = () => {};
        img.src = '/build/icons/icon-192.png';
        return;
    }
    _apply(n);
}

window.addEventListener('focus', () => {
    if (_lastN > 0 && !_pulseTimer) _startPulse();
});

document.addEventListener('visibilitychange', () => {
    if (_lastN > 0 && !_pulseTimer) _startPulse();
});
